export const userInfoKeys = {
  all: () => ['user-info'] as const,
};
